/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Flex,
  Step,
  useSteps,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useEditLocation, useGetLocation } from "../../services/locations-apis";
import {
  useLookupCashCenterRoutes,
  useLookupCashCenters,
  useLookupCountries,
  useLookupCustomers,
  useLookupMachineMakers,
  useLookupMachineModel,
  useLookupMachineTypes,
} from "../../services/lookups-mutations";
import { useLookupCurrency } from "../../services/lookups-queries";
import { SERVICE_POINT_INFORMATION } from "./constants";
import Information from "./add-service-point/Information";
import { makeEditPayload } from "./utils";
import SiteSLAs from "./add-service-point/site-SLAs";
import OperationalWindow from "./add-service-point/operational-windows";
import ServiceWindow from "./add-service-point/service-windows";
import ReplenishmentModels from "./add-service-point/replenishment-models";
import Cassettes from "./add-service-point/cassettes";
import Denominations from "./add-service-point/denominations";
import SiteRepresentative from "./add-service-point/site-representative";
import Summary from "./add-service-point/summary";

const steps = [
  { title: "Information" },
  { title: "Cassettes" },
  { title: "Denominations" },
  { title: "Timings" },
  { title: "Models" },
  { title: "Representatives" },
  { title: "SLAs" },
];
export default function EditServicePoint() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [servicePoint, setServicePoint] = useState({
    ...SERVICE_POINT_INFORMATION,
  });
  const navigate = useNavigate();
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const params = useParams();
  const {
    mutate: getCustomers,
    data: customerListRes,
    isPending: gettingCustomerList,
    // error: customerListError,
  } = useLookupCustomers();

  const {
    mutate: getMachineTypes,
    data: machineListRes,
    isPending: gettingMachineList,
    // error: machineListError,
  } = useLookupMachineTypes();

  const {
    mutate: getMakersList,
    data: makersListRes,
    isPending: gettingMakersList,
    // error: makersListError,
  } = useLookupMachineMakers();
  const {
    mutate: getModelsList,
    data: modelsListRes,
    isPending: gettingModelsList,
    // error: modelsListError,
  } = useLookupMachineModel();
  const {
    mutate: getCountries,
    data: countriesListRes,
    isPending: gettingCountriesList,
    // error: countriesListError,
  } = useLookupCountries();

  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();
  const {
    mutate: getRoute,
    data: routesListRes,
    isPending: gettingRoutesList,
    // error: routesListError,
  } = useLookupCashCenterRoutes();
  const {
    data: currencyListRes,
    isPending: gettingCurrencyList,
    // error: currencyError,
  } = useLookupCurrency();
  const {
    mutate: editRequest,
    isSuccess: isRequestEdited,
    // data: editRequestResponse,
    isPending: editingRequest,
  } = useEditLocation();
  const {
    mutate: getLocation,
    // isSuccess: isLocationAvailable,
    data: getLocationRes,
    isPending: gettingLocation,
    //     error: locationError,
    // reset: locationReset,
  } = useGetLocation();
  useEffect(() => {
    if (getLocationRes?.data && countriesListRes) {
      if (getLocationRes?.data.maker && !modelsListRes) {
        getModelsList(getLocationRes?.data.maker);
      }
      if (
        getLocationRes.data.routeNo &&
        getLocationRes.data.cashCenterId &&
        !routesListRes
      ) {
        getRoute(getLocationRes.data.cashCenterId);
      } else if (currencyListRes) {
        const _data = getLocationRes.data;
        const _payload = {
          ...makeEditPayload(
            _data,
            countriesListRes?.data || [],
            routesListRes?.data || [],
            currencyListRes?.data || []
          ),
          firstServiceDate: _data.firstServiceDate
            ? new Date(_data.firstServiceDate)
            : null,
          decomissionedDate: _data.decomissionedDate
            ? new Date(_data.decomissionedDate)
            : null,
          lockInstallationDate: _data.lockInstallationDate
            ? new Date(_data.lockInstallationDate)
            : null,
        };
        setServicePoint(_payload);
        reset(_payload);
      }
    }
  }, [
    getLocationRes,
    customerListRes,
    machineListRes,
    makersListRes,
    cashCenterList,
    countriesListRes,
    routesListRes,
    currencyListRes,
  ]);
  useEffect(() => {
    if (isRequestEdited) {
      setActiveStep(1);
      navigate(Paths.locations);
    }
  }, [isRequestEdited]);

  useEffect(() => {
    getCashCenter();
    getCustomers();
    getMachineTypes();
    getCountries();
    getMakersList();
    if (params.locationId) {
      getLocation(params.locationId);
    }
  }, []);
  const addLocation = (data) => {
    const payload = {
      customerId: data.customerId,
      cashCenterId: data.cashCenterId,
      locationId: data.locationId,
      locationName: data.locationName,
      locationCode: data.locationCode,
      category: data.category,
      routeNo: data.routeNo || "",
      locationType: data.locationType,
      status: data.status,
      siteType: data.siteType,
      fixingSide: data.fixingSide,
      loadingSide: data.loadingSide,
      machineType: data.machineType,
      maker: data.maker,
      model: data.model || "",
      lockSerialNo: data.lockSerialNo,
      machineSerialNo: data.machineSerialNo,
      barcode: data.barcode,
      siteLimit: data.siteLimit,
      distanceFromBase: data.distanceFromBase,
      coLocatedGroupNo: data.coLocatedGroupNo,
      maximumCassettes: data.maximumCassettes,
      requiresCashierCount: data.requiresCashierCount,
      requiresEVhr: data.requiresEVhr,
      hasSecurityAlarm: data.hasSecurityAlarm,
      alarmDetails: data.alarmDetails,
      country: data.country || "",
      state: data.state || "",
      emirate: data.emirate || "",
      city: data.city || "",
      address: data.address,
      longitude: !data.longitude || data.longitude === "0" ? 0 : data.longitude,
      latitude: !data.latitude || data.latitude === "0" ? 0 : data.latitude,
      lockInstallationDate: data.lockInstallationDate,
      firstServiceDate: data.firstServiceDate,
      decomissionedDate: data.decomissionedDate,
      followStandardModels: data.followStandardModels,
      followStandardDenominations: data.followStandardDenominations,
      followStandardCassettes: data.followStandardCassettes,
      dedicatedSerials: data.dedicatedSerials,
      serviceDays: data.serviceDays,
      allowedDays: data.allowedDays,
      siteSLAs: data.siteSLAs,
      operationalWindows: data.operationalWindows,
      serviceWindows: data.serviceWindows,
      cassettes: data.cassettes,
      denominations: data.denominations,
      replenishmentModels: data.replenishmentModels,
      siteRepresentatives: data.siteRepresentatives,
    };

    if (params.locationId) {
      editRequest({ ...payload, id: servicePoint.servicePointId });
    }
  };
  const getServicePointInformation = useMemo(
    () => ({
      customerId: servicePoint.customerId,
      cashCenterId: servicePoint.cashCenterId,
      locationId: servicePoint.locationId,
      locationName: servicePoint.locationName,
      locationCode: servicePoint.locationCode,
      category: servicePoint.category,
      routeNo: servicePoint.routeNo,
      locationType: servicePoint.locationType,
      status: servicePoint.status,
      siteType: servicePoint.siteType,
      fixingSide: servicePoint.fixingSide,
      loadingSide: servicePoint.loadingSide,
      machineType: servicePoint.machineType,
      maker: servicePoint.maker,
      model: servicePoint.model,
      lockSerialNo: servicePoint.lockSerialNo,
      machineSerialNo: servicePoint.machineSerialNo,
      barcode: servicePoint.barcode,
      siteLimit: servicePoint.siteLimit,
      distanceFromBase: servicePoint.distanceFromBase,
      coLocatedGroupNo: servicePoint.coLocatedGroupNo,
      maximumCassettes: servicePoint.maximumCassettes,
      requiresCashierCount: servicePoint.requiresCashierCount,
      requiresEVhr: servicePoint.requiresEVhr,
      hasSecurityAlarm: servicePoint.hasSecurityAlarm,
      alarmDetails: servicePoint.alarmDetails,
      country: servicePoint.country,
      state: servicePoint.state,
      emirate: servicePoint.emirate,
      city: servicePoint.city,
      address: servicePoint.address,
      longitude: servicePoint.longitude,
      latitude: servicePoint.latitude,
      lockInstallationDate: servicePoint.lockInstallationDate,
      firstServiceDate: servicePoint.firstServiceDate,
      decomissionedDate: servicePoint.decomissionedDate,
      followStandardModels: servicePoint.followStandardModels,
      followStandardDenominations: servicePoint.followStandardDenominations,
      followStandardCassettes: servicePoint.followStandardCassettes,
      dedicatedSerials: servicePoint.dedicatedSerials,
      serviceDays: servicePoint.serviceDays,
      allowedDays: servicePoint.allowedDays,
    }),
    [servicePoint]
  );
  const updateServicePointInformation = (information) => {
    const _servicePoint = {
      customerId: information.customerId,
      cashCenterId: information.cashCenterId,
      locationId: information.locationId,
      locationName: information.locationName,
      locationCode: information.locationCode,
      category: information.category,
      routeNo: information.routeNo,
      locationType: information.locationType,
      status: information.status,
      siteType: information.siteType,
      fixingSide: information.fixingSide,
      loadingSide: information.loadingSide,
      machineType: information.machineType,
      maker: information.maker,
      model: information.model,
      lockSerialNo: information.lockSerialNo,
      machineSerialNo: information.machineSerialNo,
      barcode: information.barcode,
      siteLimit: information.siteLimit,
      distanceFromBase: information.distanceFromBase,
      coLocatedGroupNo: information.coLocatedGroupNo,
      maximumCassettes: information.maximumCassettes,
      requiresCashierCount: information.requiresCashierCount,
      requiresEVhr: information.requiresEVhr,
      hasSecurityAlarm: information.hasSecurityAlarm,
      alarmDetails: information.alarmDetails,
      country: information.country,
      state: information.state,
      emirate: information.emirate,
      city: information.city,
      address: information.address,
      longitude: information.longitude,
      latitude: information.latitude,
      lockInstallationDate: information.lockInstallationDate,
      firstServiceDate: information.firstServiceDate,
      decomissionedDate: information.decomissionedDate,
      followStandardModels: information.followStandardModels,
      followStandardDenominations: information.followStandardDenominations,
      followStandardCassettes: information.followStandardCassettes,
      dedicatedSerials: information.dedicatedSerials,
      serviceDays: information.serviceDays,
      allowedDays: information.allowedDays,
    };
    setServicePoint({ ...servicePoint, ..._servicePoint });
  };
  const getSiteSLAs = useMemo(() => {
    return [...servicePoint.siteSLAs];
  }, [servicePoint]);
  const setSiteSLAs = (siteSLAs) => {
    const _servicePoint = { ...servicePoint };
    _servicePoint.siteSLAs = siteSLAs;
    setServicePoint(_servicePoint);
  };
  const getOperationalWindows = useMemo(() => {
    return [...servicePoint.operationalWindows];
  }, [servicePoint]);

  const setOperationalWindows = (operationalWindows) => {
    const _servicePoint = { ...servicePoint };
    _servicePoint.operationalWindows = operationalWindows;
    setServicePoint(_servicePoint);
  };
  const getServiceWindows = useMemo(() => {
    return [...servicePoint.serviceWindows];
  }, [servicePoint]);
  const setServiceWindows = (serviceWindows) => {
    const _servicePoint = { ...servicePoint };
    _servicePoint.serviceWindows = serviceWindows;
    setServicePoint(_servicePoint);
  };
  const updateReplenishmentModels = (replenishmentModels) => {
    const _servicePoint = {
      ...servicePoint,
      replenishmentModels,
    };
    setServicePoint(_servicePoint);
  };

  const getReplenishmentModels = useMemo(
    () =>
      servicePoint.replenishmentModels.map((elm) => ({
        ...elm,
        expanded: false,
      })),
    [servicePoint]
  );
  const setCassettes = (cassettes) => {
    const _servicePoint = {
      ...servicePoint,
      cassettes,
    };
    setServicePoint(_servicePoint);
  };
  const getCassettes = useMemo(
    () => [...servicePoint.cassettes],
    [servicePoint]
  );
  const setDenominations = (denominations) => {
    const _servicePoint = {
      ...servicePoint,
      denominations,
    };
    setServicePoint(_servicePoint);
  };

  const getDenominations = useMemo(
    () => [...servicePoint.denominations],
    [servicePoint]
  );
  const getSiteRepresentatives = useMemo(
    () => [...servicePoint.siteRepresentatives],
    [servicePoint]
  );
  const setSiteRepresentatives = (siteRepresentatives) => {
    const _servicePoint = {
      ...servicePoint,
      siteRepresentatives,
    };
    setServicePoint(_servicePoint);
  };
  const {
    handleSubmit,
    control,
    watch,
    resetField,
    reset,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: { ...SERVICE_POINT_INFORMATION },
  });

  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);
  return (
    <>
      {gettingCashCenterList ||
      editingRequest ||
      gettingCustomerList ||
      gettingCountriesList ||
      gettingLocation ||
      gettingRoutesList ||
      gettingMakersList ||
      gettingModelsList ||
      gettingCurrencyList ||
      gettingMachineList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Service Points", link: Paths.locations },
            { text: "Edit Service Point", isCurrentPage: true },
          ]}
        />
        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                if (activeStep === 1) {
                  updateServicePointInformation(getValues());
                }
                setActiveStep(index + 1);
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {activeStep === 1 ? (
                  (params.locationId && servicePoint.locationId) ||
                  !params.locationId ? (
                    <form>
                      <Information
                        servicePointInformation={getServicePointInformation}
                        customerList={customerListRes?.data || []}
                        cashCenters={cashCenterList?.data || []}
                        makersList={makersListRes?.data || []}
                        machineList={machineListRes?.data || []}
                        countriesList={countriesListRes?.data || []}
                        editing={Boolean(params.locationId)}
                        onMakerChange={(e) => {
                          const value = e.target.value;
                          if (value.name && value.name !== "0") {
                            getModelsList(value.name);
                          }
                        }}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        watch={watch}
                        resetField={resetField}
                        setValue={setValue}
                        reset={reset}
                        getValues={getValues}
                        modelsList={modelsListRes?.data || []}
                        onNextStep={() => {
                          updateServicePointInformation(getValues());
                          setActiveStep(2);
                        }}
                      />
                    </form>
                  ) : (
                    <></>
                  )
                ) : activeStep === 2 ? (
                  <Cassettes
                    cassettes={getCassettes}
                    disabled={watch("followStandardCassettes")}
                    followStandardCassettes={watch("followStandardCassettes")}
                    toggleStandardCassettes={() => {
                      const _value = !watch("followStandardCassettes");

                      setValue("followStandardCassettes", _value);
                    }}
                    currencies={currencyListRes?.data || []}
                    onNextStep={(cassettes) => {
                      setActiveStep(3);
                      setCassettes(cassettes);
                    }}
                    onPrevStep={(cassettes) => {
                      setActiveStep(1);
                      setCassettes(cassettes);
                    }}
                    addData={(data) => {
                      setCassettes(data);
                    }}
                  />
                ) : activeStep === 3 ? (
                  <Denominations
                    currencies={currencyListRes?.data || []}
                    disabled={watch("followStandardDenominations")}
                    followStandardDenominations={watch(
                      "followStandardDenominations"
                    )}
                    toggleStandardDenominations={() => {
                      const _value = !watch("followStandardDenominations");

                      setValue("followStandardDenominations", _value);
                    }}
                    denominations={getDenominations}
                    onNextStep={(denominations) => {
                      setActiveStep(4);
                      setDenominations(denominations);
                    }}
                    onPrevStep={(denominations) => {
                      setActiveStep(2);
                      setDenominations(denominations);
                    }}
                    addData={(data) => {
                      setDenominations(data);
                    }}
                  />
                ) : activeStep === 4 ? (
                  <>
                    <OperationalWindow
                      operationalWindows={getOperationalWindows}
                      onNextStep={(data) => {
                        setOperationalWindows(data);
                        setActiveStep(5);
                      }}
                      onPrevStep={(data) => {
                        setOperationalWindows(data);
                        setActiveStep(3);
                      }}
                      addData={(data) => {
                        setOperationalWindows(data);
                      }}
                    />
                    <ServiceWindow
                      serviceWindows={getServiceWindows}
                      addData={(data) => {
                        setServiceWindows(data);
                      }}
                    />
                  </>
                ) : activeStep === 5 ? (
                  <ReplenishmentModels
                    currencies={currencyListRes?.data || []}
                    disabled={watch("followStandardModels")}
                    models={getReplenishmentModels}
                    followStandardModels={watch("followStandardModels")}
                    toggleStandardModels={() => {
                      const _value = !watch("followStandardModels");

                      setValue("followStandardModels", _value);
                    }}
                    onNextStep={(replenishmentModels) => {
                      setActiveStep(6);
                      updateReplenishmentModels(replenishmentModels);
                    }}
                    onPrevStep={(replenishmentModels) => {
                      setActiveStep(4);
                      updateReplenishmentModels(replenishmentModels);
                    }}
                    addData={(data) => {
                      updateReplenishmentModels(data);
                    }}
                  />
                ) : activeStep === 6 ? (
                  <SiteRepresentative
                    siteRepresentatives={getSiteRepresentatives}
                    onNextStep={(siteRepresentatives) => {
                      setSiteRepresentatives(siteRepresentatives);
                      setActiveStep(7);
                    }}
                    onPrevStep={(siteRepresentatives) => {
                      setActiveStep(5);
                      setSiteRepresentatives(siteRepresentatives);
                    }}
                    addData={(data) => {
                      setSiteRepresentatives(data);
                    }}
                  />
                ) : activeStep === 7 ? (
                  <SiteSLAs
                    SLAs={getSiteSLAs}
                    onPrevStep={(data) => {
                      setActiveStep(6);
                      setSiteSLAs(data);
                    }}
                    onNextStep={(data) => {
                      setSiteSLAs(data);
                      if (isValid) {
                        setActiveStep(8);
                      } else {
                        setActiveStep(1);
                        setTriggerValidation(true);
                      }
                    }}
                    addData={(data) => {
                      setSiteSLAs(data);
                    }}
                  />
                ) : activeStep === 8 ? (
                  <Summary
                    servicePoint={servicePoint}
                    onAddServicePoint={(data) => {
                      addLocation(data);
                    }}
                    editing
                    onPrevStep={() => {
                      setActiveStep(7);
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
